<template>
    <div>
      <TableMandatos
        @view="viewModal"
        @edit="editModal"
        @add="addModal"
        :canEdit="canEdit"
        :canAdd="canAdd"
        :canDel="canDel"
        ref="tableMandato"
      />
      <ModalMandatos
        ref="modalMandato"
        v-model="show"
        @save="save"
        @new-save="newSave"
        :objMandato="objMandato"
        :acao="acao"
        :isEdit="isEdit"
        :isView="isView"
      />
      <overlay-loading :value="loadingOverlay"/>
      <SucessoModal
        :showSucess="showSucess"
        :sucessType="acao"
        successName="Mandato"
        @close="saveLoading"
      />
    </div>
</template>

<script>
import TableMandatos from './Shared/Mandatos/TableMandatos'
import ModalMandatos from './Shared/Mandatos/ModalMandatos'
import jwtDecode from 'jwt-decode'

export default {
  components: {
    TableMandatos,
    ModalMandatos
  },
  data () {
    return {
      tokenBearer: localStorage.getItem('tokenBearer'),
      role: '',
      isEdit: false,
      isView: false,
      show: false,
      objMandato: {},
      acao: '',
      loadingOverlay: false,
      showSucess: false,
      newSaveData: false,
      showModalAnexo: false
    }
  },
  methods: {
    save () {
      this.newSaveData = false
      this.show = false
      this.showSucess = true
    },
    async newSave () {
      this.show = false
      this.newSaveData = true
      if (this.isEdit && !this.isView) {
        this.acao = 'edit'
      } else if (!(this.isEdit && this.isView)) {
        this.acao = 'add'
      }
      this.showSucess = true
      this.acao = 'add'
    },
    async saveLoading () {
      this.showSucess = false
      this.show = false
      this.$refs.tableMandato.loading = true
      await this.$refs.tableMandato.loadMandatos()
      this.$refs.tableMandato.loading = false
      if (this.isEdit && !this.isView) {
        this.acao = 'edit'
      } else if (!(this.isEdit && this.isView)) {
        this.type = 'add'
      }
      if (this.newSaveData) {
        this.show = true
        this.$refs.modalMandato.clean()
        this.$refs.modalMandato.start()
      }
    },
    viewModal (obj) {
      this.objMandato = obj
      this.acao = 'view'
      this.isView = true
      this.isEdit = false
      this.show = true
      this.$refs.modalMandato.start()
    },
    editModal (obj) {
      this.objMandato = obj
      this.acao = 'edit'
      this.isView = false
      this.isEdit = true
      this.show = true
      this.$refs.modalMandato.start()
    },
    addModal () {
      this.isView = false
      this.isEdit = false
      this.acao = 'add'
      this.show = true
      this.$refs.modalMandato.start()
    }
  },
  beforeMount () {
    this.role = jwtDecode(this.tokenBearer).role
  },
  computed: {
    canEdit () {
      return this.role === 'admin_brasil' || this.role === 'dirigente'
    },
    canDel () {
      return this.role === 'admin_brasil' || this.role === 'dirigente'
    },
    canAdd () {
      return this.role === 'admin_brasil' || this.role === 'dirigente'
    }
  },
  watch: {
    showSucess () {
      if (this.newSaveData && !this.showSucess) {
        this.show = true
      }
    }
  }
}
</script>
